import React from 'react';
import Link from 'next/link';
import { cn } from '@/lib/utils';

function AppLink(props) {
  const { children, href, className = '', ...rest } = props;
  if (href) {
    return (
      <Link
        className={cn('group hover:text-text-hyperlink', className)}
        href={href}
        {...rest}>
        {children}
      </Link>
    );
  } else {
    return <a>{children}</a>;
  }
}

export default AppLink;
